import * as React from 'react';
import { SyntheticEvent } from 'react';
import { AppContext, AppContextType } from '../../AppContextType';
import { JobCenterModelInterface } from '../../Model/JobCenterModelInterface';
import { JobVacancy } from '../../Model/JobVacancy';
import { Trans } from '../Trans';

export interface AddToListButtonProps {
    model: JobCenterModelInterface
}

export class AddToListButton extends React.Component<AddToListButtonProps> {
    public static contextType = AppContextType;
    public context: AppContext = {} as AppContext;

    constructor(props: AddToListButtonProps, context: any) {
        super(props, context);
        this.handleClickAdd = this.handleClickAdd.bind(this);
        this.handleClickRemove = this.handleClickRemove.bind(this);
    }

    public render() {
        const props = this.props;
        if (this.context.selectedJobVacancies.contains(props.model.referenceId)) {
            return <button className="jc-list-button primary -remove" onClick={this.handleClickRemove}>
                <i className="fal fa-check-square"/>
                <span><Trans>Stelle von Bewerbung entfernen</Trans></span>
            </button>;
        } else {
            return <button className="jc-list-button primary -add" onClick={this.handleClickAdd}>
                <i className="fal fa-square"/>
                <span><Trans>Stelle zur Bewerbung hinzufügen</Trans></span>
            </button>;
        }
    }

    private handleClickAdd(event: SyntheticEvent) {
        event.preventDefault();
        this.context.handler.selectJobVacancy(this.props.model as JobVacancy);
    }

    private handleClickRemove(event: SyntheticEvent) {
        event.preventDefault();
        this.context.handler.unselectJobVacancy(this.props.model as JobVacancy);
    }
}
